<template>
    <el-container id="outer">
        <el-header v-bind:style="{'background': headerColor}" id="header">
            <el-row>
                <el-col :span="16">
                    <div class="logo">
                        <a :href="ncutURL" target="_blank"><img src="../assets/images/logo0506.png" style="height: 3.45rem;" alt="NCUT勤益校徵圖示" title="NCUT Logo" /></a>
                        <router-link :to="home" class="app-title">{{(null == configData? appName:configData.sysTitle)}}</router-link>
                    </div>
                </el-col>
                <el-col :span="8" style="text-align: right" class="hidden-xs-only">
                    <el-dropdown class="about">
                        <span class="el-dropdown-link">說明<i class="el-icon-arrow-down el-icon--right"></i></span>
                        <template #dropdown>
                            <el-dropdown-menu>
                                <el-dropdown-item >
                                    <a
                                            href="https://scholarshipweb.ncut.edu.tw/外語成績進步獎勵系統操作步驟.pdf" target="_blank"
                                            style="text-decoration: none"
                                    >
                                        系統手冊
                                    </a>
                                </el-dropdown-item>
                                <el-dropdown-item>
                                    <router-link
                                            :to="{name:'contactUs'}"
                                            style="text-decoration: none"
                                    >
                                        連絡我們
                                    </router-link>
                                </el-dropdown-item>
                                <el-dropdown-item>
                                    <router-link
                                            :to="{name:'aboutUs'}"
                                            style="text-decoration: none"
                                    >
                                        關於系統
                                    </router-link>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </template>
                    </el-dropdown>
                    <router-link :to="home" class="topItem name">{{name}}</router-link>
                    <a href="#" @click="signOut" class="topItem"
                        v-if="'5' != roleId">登出</a>
                    <a href="#" @click="menuClickByNm({name:'signIn'})" class="topItem"
                        v-else>登入</a>
                </el-col>
                <el-col :span="12" style="text-align: right" class="hidden-md-and-up">
                    <div id="folder">
                        <el-button
                                :icon="showCollapse ? 'el-icon-s-fold' : 'el-icon-s-unfold'"
                                type="primary"
                                size="medium"
                                @click="showCollapse=!showCollapse"
                        ></el-button>
                    </div>
                </el-col>
            </el-row>
        </el-header>
        <el-container id="middle">
            <el-aside
                    id="sidebar"
                    v-show="showSidebar"
                      style="overflow-y:auto;"
            >
                <v-menu
                        @menuClick="menuClick"
                        :menuDefs="menuDefs"
                ></v-menu>
            </el-aside>
            <el-container id="inner">
                <el-main id="main">
                    <div
                            class="animated"
                            v-if="showCollapse && !showSidebar"
                    >
                        <v-menu
                                @menuClick="menuClick"
                                :menuDefs="menuDefs"
                        >
                            <template #others>
                                <el-submenu
                                        index="about"
                                        key="about"
                                >
                                    <template #title>
                                        <span>說明</span>
                                    </template>
                                    <el-menu-item
                                            index="manual"
                                            key="manual"
                                            route=""
                                    >
                                        <a
                                                href="https://www.ncut.edu.tw" target="_blank"
                                                style="text-decoration: none; display: inline-block; width: 100%"
                                        >
                                            系統手冊
                                        </a>
                                    </el-menu-item>
                                    <el-menu-item
                                            index="contactUs"
                                            key="contactUs"
                                            @click="menuClickByNm({name:'contactUs'})"
                                    >
                                        連絡我們
                                    </el-menu-item>
                                    <el-menu-item
                                            index="aboutUs"
                                            key="aboutUs"
                                            @click="menuClickByNm({name:'aboutUs'})"
                                    >
                                        關於系統
                                    </el-menu-item>
                                </el-submenu>
                                <el-menu-item
                                        index="logout"
                                        key="logout"
                                        @click="signOut"
                                        v-if="'5' != roleId"
                                >
                                    登出
                                </el-menu-item>
                                <el-menu-item
                                        index="login"
                                        key="login"
                                        @click="menuClickByNm({name:'signIn'})"
                                        v-else
                                >
                                    登入
                                </el-menu-item>
                            </template>
                        </v-menu>
                    </div>
                    <slot></slot>
                    <el-backtop ref="backtop" target="#main"></el-backtop>
                </el-main>
                <el-footer v-bind:style="{'background': headerColor}" class="hidden-md-and-down" id="footer">
                    <span style="padding-left: 2px;"
                        v-if="null == configData">&copy;{{`${new Date().getFullYear()}`}}<a href="http://www.ncut.edu.tw"
                                                        target="_blank">{{(null == configData? '國立勤益科技大學':configData.shnm)}}</a></span>
                    <span v-else>
                        <table style=" width: 100%; padding: 0.5em 0; font-size: smaller;">
                            <tr>
                                <td v-if="0 < configData.shnm.length" style="width: 33%;">{{configData.shnm}}</td>
                                <td v-if="0 < configData.shAdd.length" style="width: 33%;">{{configData.shAdd}}</td>
                                <td v-if="0 < configData.shFax.length" style="width: 33%;">{{configData.shFax}}</td>
                            </tr>
                        </table>
                    </span>
                </el-footer>
            </el-container>
        </el-container>

    </el-container>

</template>

<script>
    import {mapGetters, mapActions, mapState} from 'vuex';
    import debounce from 'debounce';
    import appNameMixin from '../appNameMixin';
    import {getRouteDefs} from '../routes';
    import VMenu from '../components/VMenu';

    export default {
        name: 'MainLayout',
        components:{
            VMenu
        },
        data: () => ({
            selectedMenuKey: '',
            showCollapse: false,
            showSidebar: true,
            popover: false,
            configData: null
        }),
        mixins: [appNameMixin],
        computed: {
            ...mapState(['loading']),
            ...mapState('auth', ['name', 'home', 'menus', 'roleId']),
            ...mapState('config', ['config']),
            headerColor () {
                return (this.configData!=null? this.configData.bgColor: '');
            },
            menuDefs(){
                const menus = this.menus;
                let merged = []; 
                if ((null != menus) && !this.isEmpty(menus)) {
                    const routeDefs = getRouteDefs();
                    //only support 2 levels
                    for(const grp of menus){
                        if (null != grp && null != grp.subMenus) {                        
                            for(const lv1 of grp.subMenus){
                                if(lv1.isParentMenu){
                                    const parent = {...lv1, name: lv1.menuId};
                                    parent.subMenus = [];
                                    for(const lv2 of lv1.subMenus){
                                        const defL2 = routeDefs.find(r => r.name === lv2.menuId);
                                        if(defL2){
                                            const {path, exact, name} = defL2;
                                            parent.subMenus.push({...lv2, path, exact, name});
                                        }
                                    }
                                    if(parent.subMenus.length > 0){
                                        merged.push(parent);
                                    }
                                } else{
                                    const def = routeDefs.find(r => r.name === lv1.menuId);
                                    if(def){
                                        const {path, exact, name} = def;
                                        merged.push({...lv1, path, exact, name});
                                    }
                                }
                            } 
                        }
                    }
                }

                return merged;
            },

            onResize() {
                const vm = this;

                return debounce(() => {
                    const currentWidth = parseFloat(window.getComputedStyle(document.querySelector('body')).width);
                    vm.showSidebar = currentWidth >= 1000;
                    vm.popover = false;
                }, 50);
            }
        },
        methods: {
            ...mapActions({
                logout: 'auth/logout',
                initAnon: 'auth/anonInit' 
            }),
            ...mapActions('config', {
                getConfig: 'getConfig'
            }),

            menuClickByNm(def) {
                var rObj = getRouteDefs();
                //prevent duplicate route warning
                const path = (rObj.find(f => f.name === def.name) || {path: ''}).path;
                if(this.$route.path !== path){
                    this.$router.push({name:def.name});
                    this.showCollapse = false;
                }
            },

            menuClick(def) {
                //prevent duplicate route warning
                const path = (getRouteDefs().find(f => f.name === def.menuId) || {path: ''}).path;
                if(this.$route.path !== path){
                    this.$router.push({name:def.menuId});
                    this.showCollapse = false;
                }
            },

            isEmpty(obj) {
                for(var key in obj) {
                    if(obj.hasOwnProperty(key))
                        return false;
                }
                return true;
            },

            async signOut() {
                try {
                    // await this.logout();
                    await this.initAnon();
                    this.menuClickByNm({name:'root'});
                } catch (e) {                    
                }
            }
        },
        watch: {
            $route(to) {
                this.selectedMenuKey = to.name;
            },

            showCollapse(current) {
                if (current) {
                    this.$refs.backtop.scrollToTop();
                }
            },

            config(current) {
                this.configData = {...current};
            }
        },

        mounted() {
            const vm = this;
            window.addEventListener('resize', vm.onResize);
            vm.onResize();
        },

        created() {
            this.selectedMenuKey = this.$route.name;
            this.getConfig();
        },

        destroyed() {
            const vm = this;
            window.addEventListener('resize', vm.onResize);
        }
    }
</script>

<style>
    @import '../assets/styles/ncut.css';
    @import url('https://fonts.googleapis.com/css?family=Noto+Sans+TC:400,500,700,900&subset=chinese-traditional');


    #outer, #sidebar {
        min-height: 100%;
        height: 100%;
        background-color: #f0f2f5;
    }

    #outer #header {
        background: #1867c0;
        padding-right: 15px;
        min-height: 60px;
    }

    #outer #header .el-menu,
    #outer #header .el-submenu {
        height: 60px;
        line-height: 60px;
        border-bottom: none;
        margin-left: auto;
    }

    #outer #header .el-menu-item,
    #outer #header .el-submenu__title {
        font-size: 1.1rem;
    }


    #outer #header .user {
        padding-left: 10px;
        background: #1867c0;
        height: 60px;
        line-height: 60px;
        color: white;
        font-size: 1.1rem;
        cursor: pointer;
    }

    #outer #header .about{
        line-height: 60px;
        font-family: 'Noto Sans TC', sans-serif !important;
        color: white;
        font-size: 18px;
    }

    #outer #header .about:hover{
        cursor: pointer;
    }

    #outer #header .topItem.name {
        font-size: 16px;
        width: 120px;
    }

    #outer #header .topItem {
        font-family: 'Noto Sans TC', sans-serif !important;
        line-height: 60px;
        font-size: 18px;
        color: white;
        text-decoration: none;
        padding: 0 5px;
        display: inline-block;
        width: 60px;
    }

    #outer #header .app-title {
        font-family: 'Noto Sans TC', sans-serif !important;
        line-height: 60px;
        font-size: 24px;
        color: white;
        text-decoration: none;
    }

    #outer #header #folder {
        display: flex;
        margin-right: 0;
        width: 100%;
        justify-content: flex-end;
        height: 60px;
        align-items: center;
    }

    #sidebar {
        background-color: #444444;
        overflow: hidden;
    }

    #sidebar .el-menu-item,
    #sidebar .el-submenu__title {
        font-family: 'Noto Sans TC', sans-serif !important;
        font-size: 1.1rem;
    }

    #middle {
        height: calc(100vh - 60px);
    }

    #inner #main {
        padding: 0;
        margin: 0;
        box-sizing: border-box;
    }

    #inner .el-breadcrumb {
        height: 30px;
        line-height: 30px;
    }

    #inner #footer {
        font-family: 'Noto Sans TC', sans-serif !important;
        text-align: center;
        background: #1867c0;
        color: #ffffff;
    }

    #inner #footer a {
        text-decoration: none;
        font-size: 14px;
        line-height: 60px;
        color: #ffffff;
        flex: 0 !important;
    }

    #inner #folder {
        display: flex;
        margin-right: 0;
        width: 100%;
        justify-content: flex-end;
        height: 60px;
        align-items: center;
    }

</style>
